// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recover-account{
  padding:2rem;
  background-color:#fff;
}
.recover-account__back{
    display:inline-block;
    margin-bottom:1.5rem;
  }
.recover-account h1{
    font-size:1.75rem;
    line-height:2.625rem;
    margin-bottom:0.5rem;
  }
@media (width <= 640px){
.recover-account{
    padding:1.25rem
}
  }
.recover-account__more-info{
    display:flex;
    margin:1.5rem 0;
  }
.recover-account ftr-untyped-form{
    display:flex;
  }
.recover-account .form{
    display:flex;
    flex-basis:50%;
    flex-direction:column;
  }
@media (width <= 640px){
.recover-account .form{
      flex-basis:100%
  }
    }
.recover-account .form__footer{
    flex-direction:row;
    margin-top:1.5rem;
  }
.recover-account .form__footer__left-column{
      display:block;
    }
@media (width <= 640px){
        .recover-account .form__footer__left-column button.form__submit{
          width:100%;
        }
      }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
